module.exports = __webpack_public_path__ + "img/roller-coaster.befbb506.svg";